import { type SxProps, type Theme, Typography } from '@mui/material';
import { messenger } from '@side/next-zendesk-sdk';
import { useCallback } from 'react';

interface Props {
  sx?: SxProps<Theme>;
  errorCode?: string;
  interactionId?: string;
}

export const SideSupport = ({ sx, interactionId, errorCode }: Props) => {
  const handleOnClick = useCallback(() => {
    if (errorCode) {
      messenger.setErrorCode(errorCode);
    }
    if (interactionId) {
      messenger.setInteractionId(interactionId);
    }
    messenger.open();
  }, [errorCode, interactionId]);

  return (
    <Typography
      component="u"
      onClick={handleOnClick}
      sx={{
        cursor: 'pointer',
        textDecoration: 'underline',
        color: 'inherit',
        ...sx,
      }}
    >
      Side Support
    </Typography>
  );
};
